module.exports = __webpack_public_path__ + "img/google-analytics.bcf19980.jpg";